<ng-container *ngIf="item().subItems; else noSubItems">
    <a mat-list-item class="menu-item"
        (click)="toggleNested()"
        *ngIf="hasPermission(item().name)">
        <mat-icon matListItemIcon class="text-white"> {{ item().icon}}</mat-icon>

        <span matListItemTitle class="text-white" *ngIf="!collapsed()">{{item().label}}</span>
        <span matListItemMeta class="text-white">
            <mat-icon *ngIf="nestedMenuOpen()">expand_less</mat-icon>
            <mat-icon *ngIf="!nestedMenuOpen()">expand_more</mat-icon>
        </span>
    </a>
</ng-container>
<ng-template #noSubItems>
    <a mat-list-item class="menu-item"
        [routerLink]="item().routeLink"
        (click)="toggleNested()"
        routerLinkActive="selected-menu-item"
        #rla="routerLinkActive"
        [activated]="rla.isActive"
        *ngIf="hasPermission(item().name)">
        <mat-icon [fontSet]="rla.isActive?'material-icons': 'material-icons-outlined'" [class]="rla.isActive?'text-primary':'text-white'" matListItemIcon > {{ item().icon}}</mat-icon>

        <span matListItemTitle [class]="rla.isActive?'text-primary fw-bold':'text-white'" *ngIf="!collapsed()">{{item().label}}</span>
    </a>
</ng-template>
<div *ngIf="item().subItems && nestedMenuOpen()">
    <ng-container *ngFor="let subItem of item().subItems">
        <a mat-list-item class="menu-item"
            [class.indented]="!collapsed()"
            [routerLink]="item().routeLink + '/'+ subItem.routeLink"
            routerLinkActive="selected-menu-item"
            #rla="routerLinkActive"
            [activated]="rla.isActive"
            *ngIf="hasPermission(item().name)">
            <mat-icon [fontSet]="rla.isActive?'material-icons': 'material-icons-outlined'" [class]="rla.isActive?'text-primary':'text-white'" matListItemIcon > {{ subItem.icon}}</mat-icon>
            <span matListItemTitle [class]="rla.isActive?'text-primary fw-bold':'text-white'" *ngIf="!collapsed()">{{subItem.label}}</span>
        </a>
    </ng-container>
</div>